export default __webpack_public_path__ + "static/media/rx.083f50b0.png";